__turbopack_context__.v({
  "className": "jetbrains_mono_39d21c2f-module__FON6hW__className",
});
